import React, { createContext, useContext, useState, useEffect } from 'react';
import { login as apiLogin, register as apiRegister, getMe } from '../lib/api';

const AuthContext = createContext(null);

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Check if user is already logged in
  useEffect(() => {
    const checkAuth = async () => {
      const token = localStorage.getItem('token');
      if (token) {
        try {
          const response = await getMe();
          setUser(response.data);
        } catch (err) {
          localStorage.removeItem('token');
        }
      }
      setLoading(false);
    };
    checkAuth();
  }, []);

  const login = async (email, password) => {
    try {
      setError(null);
      const response = await apiLogin(email, password);
      localStorage.setItem('token', response.data.access_token);
      
      // Get user info
      const userResponse = await getMe();
      setUser(userResponse.data);
      return true;
    } catch (err) {
      setError(err.response?.data?.detail || 'Error al iniciar sesión');
      return false;
    }
  };

  const register = async (email, name, password) => {
    try {
      setError(null);
      const response = await apiRegister(email, name, password);
      localStorage.setItem('token', response.data.access_token);
      
      // Get user info
      const userResponse = await getMe();
      setUser(userResponse.data);
      return true;
    } catch (err) {
      setError(err.response?.data?.detail || 'Error al registrarse');
      return false;
    }
  };

  const logout = () => {
    localStorage.removeItem('token');
    setUser(null);
  };

  const value = {
    user,
    loading,
    error,
    login,
    register,
    logout,
    isAuthenticated: !!user,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
